export const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const panCardRegex = /([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/;
export const gstNumberRegex =
  /([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([a-zA-Z]){1}([0-9a-zA-Z]){1}$/;
export const serviceTaxRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{3}[0-9]{3}$/;
export const pdfDocReg = /(\.pdf|\.doc)$/i;
export const pdfImgReg = /(\.pdf|\.doc|\.png|\.jpg|\.jpeg)$/i;
export const StringRegex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~0-9]/;
export const ApprovTimeRegex = /^(?:[1-9]|[1-4][0-8])$/;
export const VpaRegex = /^[\w.-]+@[\w-]+(\.[\w]{2,})+$/;
export const amountRegex = /^\d+(\.\d{2})?$/;
export const accountNumberRegex = /^\d{9,18}$/;
export const transectionRegex = /^[A-Za-z0-9]{12,22}$/;
export const chequeNumberRegex = /^\d{6}$/;
export const vehicleRegex = /^[a-zA-Z0-9]*$/;

const invalidChar = ["e", "E", "+", "-"];
export const blockInvalidChar = (e) => {
  if (e.which === 38 || e.which === 40) {
    e.preventDefault();
    return;
  }
  else {
    invalidChar.includes(e.key) && e.preventDefault();
  }
}
  

export const numberTill12Regex = (e) => {
  const fieldNames = ["nightEnd", "nightStart", "maxTime"];
  const inputValue = parseFloat(e.target.value + e.key || 0);
  const hourFormat = 24;

  if (e.which === 38 || e.which === 40) {
    e.preventDefault();
    return;
  }

  // Check if the input value is already at 12 and prevent further input
  if (!isNaN(inputValue) && inputValue > hourFormat ) {
    e.preventDefault();
    return;
  }

  if (invalidChar.includes(e.key) || e.key === ".") {
    e.preventDefault();
    return;
  }

  if (fieldNames.includes(e.target.name)) {
    // Check if the key is in the list of invalid characters or if the key is a decimal point
 
    // Prevent entering multiple leading zeroes
    if (inputValue === 0 && e.key === "0" && !e.target.value.includes("0")) {
      e.preventDefault();
      return;
    }
  }
};

export const imageSize = {
    fileSize : 1048576,
    fiveMb : 5120000
  }

export const csvReg = /(\.csv)$/i;
